import React from "react";
import { NumericFormat } from "react-number-format";
import { Input } from "./ui/input";
import { cn } from "../lib/utils";

const CURRENCY_INPUT_FORMATS = {
  BRL: {
    prefix: "R$ ",
    decimalSeparator: ",",
    thousandSeparator: ".",
  },
};

export const CurrencyInput = ({
  className,
  onChange,
  value,
  customRef,
  currency = "BRL",
  allowNegative = false,
  decimalScale = 5,
  fixedDecimalScale = false,
  ...props
}) => {
  const format = CURRENCY_INPUT_FORMATS[currency] || CURRENCY_INPUT_FORMATS.BRL;

  return (
    <NumericFormat
      {...props}
      customInput={Input}
      decimalSeparator={format.decimalSeparator}
      thousandSeparator={format.thousandSeparator}
      prefix={format.prefix}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      valueIsNumericString={true}
      allowNegative={allowNegative}
      className={cn("font-mono text-lg", className)}
      getInputRef={customRef}
      value={value}
      onValueChange={(values) => {
        onChange?.(values.value);
      }}
    />
  );
};

CurrencyInput.displayName = "CurrencyInput";
